import { NativeStackScreenProps } from "@react-navigation/native-stack";
import {
  CheckoutRootParamList,
  CheckoutSummaryMoreActionsRootParamList,
} from "../../../../types";
import {
  createStackHeaderNavigator,
  ModalCloseButton,
} from "@towersystems/roam-common-native";
import { CheckoutSummaryMoreActionsScreen } from "../CheckoutSummaryMoreActionsScreen";
import { CardStyleInterpolators } from "@react-navigation/stack";
import { EditPurchaseOrderNumberScreen } from "../EditPurchaseOrderNumberScreen";

export type CheckoutSummaryMoreActionsRootScreenProps = NativeStackScreenProps<
  any & CheckoutRootParamList,
  "CheckoutSummaryMoreActionsRootScreen"
>;

const RootStack =
  createStackHeaderNavigator<CheckoutSummaryMoreActionsRootParamList>();

export const CheckoutSummaryMoreActionsRootScreen =
  ({}: CheckoutSummaryMoreActionsRootScreenProps) => {
    return (
      <RootStack.Navigator
        screenOptions={{
          headerShown: false,
        }}
      >
        <RootStack.Group
          screenOptions={{
            headerShown: true,
            headerLeft: () => <ModalCloseButton />,
            animationEnabled: true,
            title: "",
            cardStyleInterpolator: CardStyleInterpolators.forHorizontalIOS,
          }}
        >
          <RootStack.Screen
            name="CheckoutSummaryMoreActionsScreen"
            component={CheckoutSummaryMoreActionsScreen}
          />
          <RootStack.Screen
            name="EditPurchaseOrderNumberScreen"
            component={EditPurchaseOrderNumberScreen}
            options={{
              headerLeft: () => <ModalCloseButton type="Back" />,
            }}
          />
        </RootStack.Group>
      </RootStack.Navigator>
    );
  };
